const dappTracking = {
  dappActivityTracking: {
    contracts: [
      {
        lastQueriedBlock: 1824399,
        _id: "676961a6e2955c94f05a495c",
        entity: "67049db39b7e1c1327b3d52c",
        chainId: 2818,
        name: "USDC on Morph",
        contractAddress: "0xe34c91815d7fc18a9e2148bcd4241d0a5848b693",
        created: "2024-12-23T13:12:06.483Z",
        updated: "2024-12-27T06:16:26.353Z",
        __v: 0,
      },
      {
        lastQueriedBlock: 65963853,
        _id: "676a2165eb57f04eeb04fc57",
        entity: "67049db39b7e1c1327b3d52c",
        chainId: 137,
        name: "DSLA",
        contractAddress: "0xa0e390e9cea0d0e8cd40048ced9fa9ea10d71639",
        created: "2024-12-24T02:50:13.255Z",
        updated: "2024-12-27T06:16:34.998Z",
        __v: 0,
      },
    ],
  },
  dappTracking: {
    stats: {
      dataInfo: [
        {
          dataTitle: "Unique Wallet Count",
          number: 1162,
          rate: 16.2,
          id: "uniqueWalletCount",
        },
        {
          dataTitle: "Transactions",
          number: 1753,
          rate: 48.559322033898304,
          id: "transactions",
        },
        {
          dataTitle: "Avg. Transactions",
          number: 1.508605851979346,
          rate: 27.847953557571696,
          id: "avgTransactions",
        },
      ],
    },
    walletActivityOverview: {
      data: [
        {
          date: "2024-12-21",
          uniqueWallets: 203,
          transactions: 283,
        },
        {
          date: "2024-12-22",
          uniqueWallets: 163,
          transactions: 227,
        },
        {
          date: "2024-12-23",
          uniqueWallets: 166,
          transactions: 232,
        },
        {
          date: "2024-12-24",
          uniqueWallets: 230,
          transactions: 302,
        },
        {
          date: "2024-12-25",
          uniqueWallets: 319,
          transactions: 371,
        },
        {
          date: "2024-12-26",
          uniqueWallets: 300,
          transactions: 338,
        },
        {
          date: "2024-12-27",
          uniqueWallets: "N/A",
          transactions: "N/A",
        },
      ],
    },
    newWallets: {
      data: [
        {
          date: "2024-12-21",
          newWallets: 132,
        },
        {
          date: "2024-12-22",
          newWallets: 115,
        },
        {
          date: "2024-12-23",
          newWallets: 119,
        },
        {
          date: "2024-12-24",
          newWallets: 171,
        },
        {
          date: "2024-12-25",
          newWallets: 233,
        },
        {
          date: "2024-12-26",
          newWallets: 198,
        },
        {
          date: "2024-12-27",
          newWallets: "N/A",
        },
      ],
    },
    cohort: {
      data: {
        days: {
          "21-12-2024": [132, 31, 8, 10, 24, 7, 1],
          "22-12-2024": [115, 40, 6, 7, 5, 2],
          "23-12-2024": [119, 42, 4, 11, 1],
          "24-12-2024": [171, 66, 18, 3],
          "25-12-2024": [233, 73, 6],
          "26-12-2024": [198, 57],
          "27-12-2024": ["N/A"],
        },
      },
    },
  },
};

export default dappTracking;
